import { posthog } from 'posthog-js';

if (typeof window !== 'undefined') {
  if (import.meta.env.ENV_POSTHOG_KEY) {
    posthog.init(import.meta.env.ENV_POSTHOG_KEY, {
      api_host: import.meta.env.ENV_POSTHOG_HOST,
      defaults: '2025-05-24'
    });
  } else {
    /* oxlint-disable-next-line no-console */
    console.warn('ENV_POSTHOG_KEY is not defined. PostHog is not running.');
  }
}
